/**
 * Joker 显示配置
 * 分类颜色、卡面背景、描述文本关键词高亮规则
 */

import type { JokerCategory } from '../engine/types'

export const JOKER_CATEGORY_COLORS: Record<JokerCategory, string> = {
  chips: '#7CAFC2',
  mult: '#D4849A',
  x_mult: '#C9A96E',
  conditional: '#7DAF8B',
  utility: '#A0A0A0',
}

/** 每个分类的卡面浅色背景 */
export const JOKER_CATEGORY_BG: Record<JokerCategory, string> = {
  chips:       'linear-gradient(160deg, #D6E8F0 0%, #BDD8E6 40%, #C8DFE9 100%)',
  mult:        'linear-gradient(160deg, #F0D6E0 0%, #E6BDD0 40%, #EBCAD8 100%)',
  x_mult:      'linear-gradient(160deg, #F0E6D0 0%, #E6D6B8 40%, #EBDCC5 100%)',
  conditional: 'linear-gradient(160deg, #D6F0DC 0%, #BDE6C8 40%, #C8E9D0 100%)',
  utility:     'linear-gradient(160deg, #E4E2E8 0%, #D5D3DA 40%, #DCDAE0 100%)',
}

/** 关键词高亮：数值、Chips/Mult、牌型、花色、增强 */
export const JOKER_KEYWORD_RULES: { pattern: RegExp; color: string }[] = [
  { pattern: /(\+\d+|×[\d.]+|×)/g,                                       color: '#E8D060' },  // 数值
  { pattern: /\bChips\b/gi,                                               color: '#7CAFC2' },  // chips
  { pattern: /\bMult\b/gi,                                                color: '#D4849A' },  // mult
  { pattern: /\b(Pair|Two Pair|Full House|Flush|Straight|Three of a Kind|Four of a Kind|Five of a Kind|Straight Flush|High Card)\b/gi, color: '#C9A96E' },
  { pattern: /\b(Ace|Wild|Foil|Holo|Polychrome|Glass|Steel)\b/gi,         color: '#C9A96E' },
  { pattern: /\b(depth \d|K)\b/g,                                         color: '#A0B8D0' },
]
